module.exports = __webpack_public_path__ + "static/media/news-spmi-member-photo.a317c4ca.jpg";